module.exports = __webpack_public_path__ + "static/img/title.cd17a3b1.png";